import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { DashboardRecord } from "@/lib/dashboard/types";
import { useRestClient } from "@/lib/restClient";
import { dashboardQueryKey } from "./useDashboard";

type DestinationSettings = Pick<
  DashboardRecord["config"],
  "scope" | "refresh" | "refreshMode" | "filters" | "focusMode" | "presentationMode"
>;

export interface TemplateOperationInput {
  id: string;
  slug?: string;
  name?: string;
  description?: string;
  catalog_tenant_ids?: number[];
  settings?: DestinationSettings;
}

export function useTemplateOperation(action: "instantiate" | "copy-template") {
  const apiFetch = useRestClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }: TemplateOperationInput) =>
      apiFetch<DashboardRecord>(`/api/dashboards/${encodeURIComponent(id)}/${action}`, {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: (record) => {
      queryClient.setQueryData(dashboardQueryKey(record.id, record.kind), record);
      void queryClient.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
}
